<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-primary print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center justify-center p-4">
            <!-- Logo -->
            <div class="flex items-center">
                <img class="mx-2 w-8" src="images/logo/icon.png" />
                <p class="text-2xl">EFRISBuddy</p>
            </div>
        </div>
        <!-- User -->
        <!--<div class="flex w-full flex-col items-center p-4">
            <div class="relative h-24 w-24">
                @if (user.avatar) {
                    <img
                        class="h-full w-full rounded-full"
                        [src]="user.avatar"
                        alt="User avatar"
                    />
                }
                @if (!user.avatar) {
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_solid:user-circle'"
                    ></mat-icon>
                }
            </div>
            <div class="mb-6 mt-6 flex w-full flex-col items-center justify-center">
            <div
                class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
            >
                {{ user.name }}
            </div>
            <div
                class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
            >
                {{ user?.activeBranch?.branchName }}
            </div>
        </div>
        </div>-->
    </ng-container>
    <!-- Navigation footer hook -->
    <!--<ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12"
        >
            <p>
                <img class="max-w-10" src="images/logo/icon.png" />
            </p>
            <p class="mx-2">EFRISBuddy &copy; {{ currentYear }}</p>
        </div>
    </ng-container>-->
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->

        <div class="absolute left-1/2 -translate-x-1/2 transform">
            <div
                class="text-base font-normal tracking-tight text-gray-900 dark:text-gray-100 sm:text-xl"
            >
                {{ user?.activeBranch?.branchName }}
            </div>
        </div>
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <!--<languages></languages>-->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!--<search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>-->
            <messages></messages>
            <user [showAvatar]="true"></user>
            <!--<button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button>-->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary text-center text-sm"
            >For support please call Gerald at: 256740411880 or Ahmad at:
            256701222383 | EFRISBuddy is a product of AJ Consults Ltd</span
        >
    </div>
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
<!--End of Tawk.to Script-->
